import { useState } from "react";
import css from "./PlaceholderImageAlt.module.scss";

// type: rect / circle

export default function PlaceholderImageAlt({
   src,
   alt,
   type = "rect",
   iconUnicode = "",
   boxStyles,
   size = "64px",
}) {
   const [imageIsValid, setImageIsValid] = useState(src);

   function handleOnError() {
      setImageIsValid(false);
   }

   return (
      // <object
      //    data={src}
      //    type="image/png"
      //    width="64"
      //    height="64"
      // >
      <div
         className={`${css["box"]} ${css[type]} ${imageIsValid ? "" : css["no-image"]}`}
         data-icon={iconUnicode}
         // style={{ width: size, height: size }}
         style={{"--size": size}}
      >
         {/* {imageIsValid ? "yes" : "no"} */}
         <img
            src={src}
            className={css["image"]}
            alt={alt}
            height={size}
            width={size}
            onError={handleOnError}
         />
      </div>
      // </object>
   );
}